import type { ReactNode } from 'react';

import { AuthProvider as BaseAuthProvider, type AuthConfig } from '@repo/auth';

interface AuthProviderProps {
  children: ReactNode;
}

/**
 * Tenant UI Authentication Provider
 *
 * Wraps the shared AuthProvider with tenant-ui specific configuration.
 *
 * @example
 * ```tsx
 * <AuthProvider>
 *   <App />
 * </AuthProvider>
 * ```
 */
export function AuthProvider({ children }: AuthProviderProps) {
  const config: AuthConfig = {
    authority: import.meta.env.VITE_ZITADEL_ISSUER || 'http://localhost:8081',
    clientId: import.meta.env.VITE_ZITADEL_CLIENT_ID || '',
    appUrl: import.meta.env.VITE_APP_URL || 'http://localhost:3020',
    callbackPath: '/auth/callback',
    debug: process.env.NODE_ENV === 'development',
  };

  return <BaseAuthProvider config={config}>{children}</BaseAuthProvider>;
}
